import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateBoardV3 = OpalApi<'UpdateBoardV3', 200>

export const updateBoard: UpdateBoardV3 = async (args = {}) => {
  const boardId = args.params?.path.board_id

  if (typeof boardId !== 'string') {
    throw new Error('Must supply a valid board_id.')
  }

  const url = new URL(`/boards/v3/${boardId}`, window.location.origin)

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
